module.exports = __webpack_public_path__ + "img/eae-slide-6.41665809.jpg";